import axios from 'axios';

export const URL_API_USER = process.env.REACT_APP_API_URL || 'https://ratesapi.mycontainers.ru';

export function authConfigAxios(apiURL?: string) {
  const requestBase = axios.create({
    baseURL: apiURL,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    withCredentials: true
  });

  requestBase.interceptors.request.use(
    (config) => {
      config.params = { ...config.params };
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
  requestBase.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      const errorMessage = error?.response?.data?.message ? error?.response?.data : '';
      if (error?.response?.status === 401) {
        // возможем такой сценарий какие то действия;
        return Promise.reject(errorMessage || {message: 'Ошибка доступа 401' });
      }
      if (error?.response?.status === 404) {
        // возможем такой сценарий какие то действия;
        return Promise.reject(errorMessage || {message: 'Ошибка запроса 404'});
      }
      return Promise.reject(errorMessage || {message: 'Ошибка сервера'});
    },
  );

  return requestBase;
}


export const apiAxios = authConfigAxios(URL_API_USER);
